import React, { forwardRef, useImperativeHandle } from 'react';
import { Select } from 'tea-component';
import { addFilterBuriedPoint } from '../../utils/point';
import { AllFilterPointType } from '@op/operationLog/pages/filter';

function CustomSingleSelect(
  {
    placeholderText,
    selectValueInfo,
    options,
    pointKey,
    disabled = false
  }: {
    placeholderText: string;
    selectValueInfo: [string, (value: string) => void];
    options: Array<{ text: string; value: string }>;
    pointKey?: AllFilterPointType;
    disabled?: boolean;
  },
  ref: React.Ref<unknown> | undefined,
) {
  let [selectValue, setSelectValue] = selectValueInfo;

  // dropdown组件的button属性
  const buttonElement = (onlyResult?: boolean) => {
    let text = <span className="select-button-text">{placeholderText}</span>;
    const itemInfo = options.find((item) => item.value === selectValue);
    let showElement = itemInfo?.text;
    return onlyResult ? (
      [showElement, false]
    ) : (
      <>
        {text} <span className="select-button-value">{showElement}</span>
      </>
    );
  };

  useImperativeHandle(ref, () => ({
    buttonElement: buttonElement(true),
  }));

  return (
    <Select
      options={options}
      value={selectValue}
      appearance="button"
      size="m"
      disabled={disabled}
      matchButtonWidth
      onChange={(value) => {
        setSelectValue(value);
        try {
          addFilterBuriedPoint(pointKey, value);
        } catch (error) {}
      }}
      button={buttonElement()}
    />
  );
}

export default forwardRef(CustomSingleSelect);
